import { configureStore } from '@reduxjs/toolkit';
import branchSlice from './features/branchSlice';
import cartSlice from './features/cartSlice';
import deviceSlice from './features/deviceSlice';
import packageSlice from './features/packageSlice';
import parkSlice from './features/parkSlice';
import userSlice from './features/userSlice';
import tokenSlice from './features/tokenSlice';

const store = configureStore({
    reducer: {
        deviceSlice,
        userSlice,
        cartSlice,
        packageSlice,
        parkSlice,
        branchSlice,
        tokenSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            // Example of customization: Disable serializable state check
            serializableCheck: false,
        }),
});
export default store;
